'use strict';

exports.__esModule = true;
exports.CONTACT_REQUEST = exports.CLOSE = exports.OPEN = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _doctifyUtils = require('doctify-utils');

var _constants = require('../utils/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

var OPEN = exports.OPEN = 'TELEPHONE_MODAL_ACTIONS:OPEN';
var CLOSE = exports.CLOSE = 'TELEPHONE_MODAL_ACTIONS:CLOSE';
var CONTACT_REQUEST = exports.CONTACT_REQUEST = 'TELEPHONE_MODAL_ACTIONS:CONTACT_REQUEST';

var TelephoneModalModalActions = {
  openModal: function openModal() {
    return {
      type: OPEN
    };
  },
  closeModal: function closeModal() {
    return {
      type: CLOSE
    };
  },
  makeContactRequest: function makeContactRequest(data) {
    return function (dispatch) {
      var actionConfig = {
        actionType: CONTACT_REQUEST,
        url: '/specialists/' + data.id + '/contact_request',
        method: 'POST',
        data: data
      };

      if (!_constants.GOOGLE_RECAPTCHA_APP_KEY) {
        return dispatch((0, _doctifyUtils.createAction)((0, _assign2.default)({}, actionConfig, { headers: {} })));
      }

      return window.grecaptcha.execute(_constants.GOOGLE_RECAPTCHA_APP_KEY, { action: 'submit' }).then(function (token) {
        var headers = {
          'google-recaptcha-token': token,
          'google-recaptcha-site-id': _constants.GOOGLE_RECAPTCHA_APP_KEY
        };

        return dispatch((0, _doctifyUtils.createAction)((0, _assign2.default)({}, actionConfig, { headers: headers })));
      }).catch(function (error) {
        console.error('Error obtaining reCAPTCHA token:', error);
      });
    };
  }
};

exports.default = TelephoneModalModalActions;


// WEBPACK FOOTER //
// ./components/specialist-page/lib/actions/telephone-modal.js